//Angular imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

//3rd party modules
import {
  DxBoxModule,
  DxButtonModule,
  DxFormModule,
  DxLoadPanelModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxListModule,
  DxScrollViewModule,
  DxValidationGroupModule,
  DxValidatorModule
} from 'devextreme-angular';

//Component imports
import { AddPropertyComponent } from './add-property/add-property.component';
import { AddPropertyModalComponent } from './add-property-modal/add-property-modal.component';
import { SelectPropertyComponent } from './select-property/select-property.component';
import { DefaultPropertyComponent } from './default-property/default-property.component';

@NgModule({
  declarations: [
    AddPropertyComponent,
    AddPropertyModalComponent,
    SelectPropertyComponent,
    DefaultPropertyComponent
  ],
  exports: [
    SelectPropertyComponent,
    DefaultPropertyComponent,
    AddPropertyModalComponent
  ],
  imports: [
    CommonModule,
    DxBoxModule,
    DxButtonModule,
    DxFormModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxListModule,
    DxScrollViewModule,
    DxValidationGroupModule,
    DxValidatorModule
  ]
})
export class PropertyModule {}
